import { HoopsApi, useAPIAction } from "melco-shared-logic";

export const useDownloadHoop = (
    id: string | undefined
) => {
    return useAPIAction(
        HoopsApi,
        async (api) => {
            const data = await api.hoopsDownloadHoop({
                id: id ?? ""
            });
            //  console.log(data)
            return {
                successMessages: [],
                data,
            };
        },
        { translationPrefix: "global" }
    );
};
